/// <reference path="../../../typings/externals.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var observable = require('../Observable');
var PubnubMock = (function (_super) {
    __extends(PubnubMock, _super);
    function PubnubMock(context, options) {
        this.options = options;
        this.crypto_obj = context.getPubnubReal().crypto_obj;
        _super.call(this, context);
    }
    PubnubMock.prototype.ready = function () { };
    PubnubMock.prototype.subscribe = function (options) {
        this.on('message-' + options.channel, options.message);
    };
    PubnubMock.prototype.unsubscribe = function (options) {
        this.off('message-' + options.channel);
    };
    PubnubMock.prototype.receiveMessage = function (msg, channel) {
        this.emit('message-' + channel, msg, 'env', channel);
    };
    return PubnubMock;
})(observable.Observable);
exports.PubnubMock = PubnubMock;
var PubnubFactory = (function () {
    function PubnubFactory(context) {
        this.context = context;
        this.crypto_obj = context.getPubnubReal().crypto_obj;
    }
    PubnubFactory.prototype.init = function (options) {
        return new PubnubMock(this.context, options);
    };
    return PubnubFactory;
})();
exports.PubnubFactory = PubnubFactory;
function $get(context) {
    return new PubnubFactory(context);
}
exports.$get = $get;



/*****************
 ** WEBPACK FOOTER
 ** ./src/lib/core/pubnub/PubnubMock.ts
 ** module id = 1
 ** module chunks = 0
 **/